import type { Metrics } from 'components/ai/assistant/types';

export function formatMetrics(metrics?: Metrics | null) {
  if (!metrics) {
    return null;
  }

  const parts = [
    formatLatencyMs(metrics.latencyMs),
    formatCost(metrics.cost),
  ];

  if (metrics.inputTokens != null && metrics.outputTokens != null) {
    parts.push(`${metrics.inputTokens.toLocaleString()} in / ${metrics.outputTokens.toLocaleString()} out`);
  }

  if (metrics.model) {
    parts.push(metrics.model);
  }

  return parts.join(' · ');
}

function formatCost(cost?: number | null) {
  return cost == null ? '$?' : `$${cost.toFixed(4)}`;
}

function formatLatencyMs(latencyMs?: number | null) {
  return `${latencyMs == null ? '?' : (latencyMs / 1000).toFixed(1)}s`;
}
